import { FileUpload } from 'components/Forms/InvitationForm/fileUpload';
import { types, Instance } from 'mobx-state-tree';
const { string, maybeNull, model, maybe, array, union } = types;

const CustomAttributeModel = model({
  label: string,
  type: string,
  name: maybe(string),
  options: array(string),
  value: maybeNull(union(string, array(string))),
});

export const EndUserProfileInfoModel = model('EndUserProfileInfoModel', {
  address: maybeNull(string),
  password: maybeNull(string),
  profileUrl: maybeNull(string),
  confirm_password: maybeNull(string),
  oldPassword: maybeNull(string),
  email: string,
  firstName: string,
  lastName: maybeNull(string),
  lastLogin: maybeNull(string),
  organizationName: maybeNull(string),
  profileImg: maybeNull(FileUpload),
  phone: maybeNull(string),
  personalAddress: maybeNull(string),
  roles: maybeNull(string),
  groups: maybeNull(string),
  departments: maybeNull(string),
  // groups: maybeNull(union(string, array(string))),
  // departments: maybeNull(union(string, array(string))),
  base: maybeNull(string),
  group: maybeNull(string),
  middleName: maybeNull(string),
  customAttribute: array(CustomAttributeModel),
  userRequest: maybeNull(string),
  department_name: maybeNull(string),
  group_names: array(string),
});
export type IEndUserProfileInfoModel = Instance<typeof EndUserProfileInfoModel>;

export const EndUserPasswordInfoModel = model('EndUserPasswordInfoModel', {
  password: maybeNull(string),
  password_confirmation: maybeNull(string),
  current_password: maybeNull(string),
});
export type IEndUserPasswordInfoModel = Instance<typeof EndUserPasswordInfoModel>;

// export type IEndUserProfileInfoModel = Instance<typeof EndUserProfileInfoModel>;
// export const LDAPUserModel = model('LDAPUserModel', {
//   dn: string,
//   uid: maybe(string),
//   cn: string,
//   base: maybe(string),
//   sn: string,
//   displayname: maybe(string),
//   givenname: maybe(string),
//   description: maybe(string),
//   mail: identifier,
//   l: maybe(string),
//   st: maybe(string),
//   postaladdress: maybe(string),
//   roomnumber: maybe(string),
//   telephonenumber: maybe(string),
//   mobile: maybe(string),
//   pager: maybe(string),
//   facsimiletelephonenumber: maybe(string),
//   labeleduri: maybe(string),
//   preferredlanguage: maybe(string),
//   userpassword: maybe(string),
//   passwordMethod: maybe(string),
//   homepostaladdress: maybe(string),
//   homephone: maybe(string),
//   o: maybe(string),
//   ou: maybe(string),
//   departmentnumber: maybe(string),
//   employeenumber: maybe(string),
//   employeetype: maybe(string),
//   objectclass: array(string),
//   manager: maybe(string),
//   locked: maybe(boolean),
//   notify: maybe(boolean),
//   createtimestamp: maybeNull(string),
//   modifytimestamp: maybeNull(string),
//   appStatus: maybe(boolean),
//   googleId: maybeNull(string),
//   zoomId: maybeNull(string),
//   microsoftId: maybeNull(string),
//   reSyncProvider: array(string),
//   isTwoFactorEnable: maybe(boolean),
//   customAttribute: array(CustomAttributeModel),
// });

// export type ILDAPUserModel = Instance<typeof LDAPUserModel>;
